import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { Driver, DriverTypeEnum } from '../../store/ducks/freight/types';
import { populateDrivers } from '../../store/ducks/tables/actions';

export interface GetDriversResponse {
  page: number;
  rows: Driver[];
  totalRecords: number;
}

export default function useGetDrivers() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    username?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    type?: DriverTypeEnum;
  }): Promise<GetDriversResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/drivers', {
        params: {
          rowsPerPage: params.rowsPerPage || 20,
          page: params.page,
          username: params.username,
          status: params.status !== 'Todos' ? params.status : undefined,
          startDate: params.startDate,
          endDate: params.endDate,
          type: params.type,
        },
      });

      if (response.status === 200) {
        dispatch(populateDrivers(response.data));
        return response.data;
      }
      return response.data;
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
